import { ViewSettings } from 'ontime-types';

export const viewsSettingsPlaceholder: ViewSettings = {
  dangerColor: '#ED3333',
  endMessage: '',
  freezeEnd: false,
  normalColor: '#ffffffcc',
  overrideStyles: false,
  warningColor: '#FFAB33',
};
